import { BottomActionRef } from '@euler/app/components/BottomAction';
import {
  createContext,
  memo,
  ReactNode,
  RefObject,
  useMemo,
  useRef,
} from 'react';
import { SharedValue, useSharedValue } from 'react-native-reanimated';

export type TabContextProps = {
  scrollY: SharedValue<number>;
  ref: RefObject<BottomActionRef>;
};

export const TabContext = createContext<TabContextProps>(null as any);

export const TabContextProvider = memo(
  ({ children }: { children?: ReactNode }) => {
    const scrollY = useSharedValue(0);
    const ref = useRef<BottomActionRef>(null);
    const value = useMemo(() => ({ scrollY, ref }), [scrollY, ref]);
    return <TabContext.Provider value={value}>{children}</TabContext.Provider>;
  },
);
